import axios from '../../config';
import { getValue, setValue, removeDuplicates } from '../../utility.js';
import { setCartCount } from './cartCountAction';
export const SET_ALL_CATEGORIES = "SET_ALL_CATEGORIES";
export const CLEAR_ALL_CATEGORIES = "CLEAR_ALL_CATEGORIES";
export const USER_SELECT_CATEGORIES = "USER_SELECT_CATEGORIES";

export const setProductAllCategories = (payload: any) => ({
    type: SET_ALL_CATEGORIES,
    payload
})

export const setUserProductCategories = (payload: any) => ({
    type: USER_SELECT_CATEGORIES,
    payload
})

export const clearUserProductCategories = () => ({
    type: CLEAR_ALL_CATEGORIES,
})

export const fetchProductAllCategories = () => async (dispatch:any) => {
    let postalCode = JSON.parse(localStorage.getItem("postalCode") || '')
    const base_url = process.env.REACT_APP_BACKEND_URL;
    try {

        const bodyFormData = new FormData();
        const currentShopId = localStorage.getItem("currentShopHome");
        let URL = window.location.href.split("/");
        let api_url = `${base_url}/api/get_all_categories?group_id=1&pincode=${postalCode}`;
        if (URL.length > 4) {
          api_url = `${base_url}/api/get_all_categories?group_id=1&shop_id=${currentShopId}&pincode=${postalCode}`;
        }
        const isLaundryUpDomain =
          window.location.host.includes("laundryup") ||
          window.location.host.includes("localhost");

        const fromVal = localStorage.getItem("from") || getValue("from");
        const wbdVal = getValue("wbd");
        const postalCodeStr = (typeof postalCode === "string" ? postalCode : JSON.stringify(postalCode || "")).replace(/"/g, "").toUpperCase();

        const isWbd =
          Boolean(isLaundryUpDomain) &&
          (fromVal === "wbd" || postalCodeStr === "WBD") &&
          wbdVal !== false &&
          localStorage.getItem("wbd") !== "false";

        if (isWbd) {
          api_url += `&wbd=true`;
        } else {
          if (fromVal !== "wbd") {
            setValue("wbd", false);
            localStorage.removeItem("wbd");
          }
        }

        // bodyFormData.append('keyword', value);
        // res.header('Access-Control-Allow-Methods', 'GET, POST');
        const response = await axios({
            method: "get",
            url: api_url,
            data: bodyFormData,
            headers: { "Accept": "application/json", 'Access-Control-Allow-Methods': 'GET, POST' },
        })
        // const response = await axios.post(`${base_url}/api/get_postal_codes`,{keyword:"Gu11"});
        // const result = await response.then(response => response);

        if (response) {
            // setPostalCodeList(response.data.data[0])
            let cartInformationData = getValue("cartInformationData",[]);

            // Filter disabled categories for WBSL / WBD flow
            if (isWbd && response.data?.data) {
                const disabledCats = response.data.data.disabled_categories || [];
                if (disabledCats.length > 0 && Array.isArray(response.data.data.category)) {
                    const disabledStrIds = disabledCats.map((id: any) => id.toString());
                    response.data.data.category = response.data.data.category.filter(
                        (item: any) => !disabledStrIds.includes(item.main_category_id?.toString())
                    );
                    if (cartInformationData.length) {
                        cartInformationData = cartInformationData.filter(
                            (item: any) => !disabledStrIds.includes(item.main_category_id?.toString())
                        );
                        setValue("cartInformationData", cartInformationData);
                    }
                }
            }

            if(cartInformationData.length && response.data){
                const cartCount = cartInformationData.map((item:any) => item.sub_categories.reduce((a:number,b:any) =>  a + Number(b.quantity),0 )).reduce((a:number,b:number) => a+b,0);
                dispatch(setCartCount(cartCount));
                cartInformationData = [...cartInformationData,...response.data.data.category];
                response.data.data.category = removeDuplicates(cartInformationData,"main_category_id");
                dispatch(setProductAllCategories(response.data));
            }else{
                dispatch(setProductAllCategories(response.data))
            }
            return response.data
        }
    } catch (error) {
        
    }
   
};